import { defineMessages } from 'react-intl';

export default defineMessages({
  subjectRecharge: 'Doładowanie konta',
  subjectActivate: 'Aktywacja baterii/testu',
  addressee: 'Koordynator placówki',
});
